"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLDirectoryElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLDirectoryElementImpl
};
